@if (careproviderUnit()) {
  <div class="flex flex-col gap-4">
    @if (mainImage()) {
      <div (click)="openImageGallery()"
           class="item-image w-full h-40 lg:h-44 relative rounded cursor-pointer">
        <img [alt]="careproviderUnit().name" [ngSrc]="mainImage()" [placeholderConfig]="{blur: false}"
             class="h-full w-full cursor-pointer object-cover object-[50%_30%] rounded-lg border border-grey-8"
             [attr.fetchpriority]="'high'"
             [priority]="true"
             fill="true"
             placeholder="data:image/png;base64,UklGRloAAABXRUJQVlA4IE4AAABQBwCdASqgAGQAP3G42GU0ryunIIgCkC4JaQAW30AntsReIBVVREKt3CqqIhceIVVREakRCqqJE4iIVVSXVURCqqAAAP7tqAAAAAAAAAA=">

        @if (logoUrl() && logoUrl() !== '') {
          <div
            class="w-16 h-16 bg-white rounded-full absolute top-2 left-2 border border-grey-8 justify-center items-center lg:w-20 lg:h-20 lg:-top-3 lg:-left-3">
            <img
              [alt]="careproviderUnit().name + ' logo'"
              [ngSrc]="logoUrl()"
              [placeholderConfig]="{blur: false}"
              class="object-contain rounded-full"
              [attr.fetchpriority]="'high'"
              [priority]="true"
              fill="true"
              placeholder="data:image/png;base64,UklGRloAAABXRUJQVlA4IE4AAABQBwCdASqgAGQAP3G42GU0ryunIIgCkC4JaQAW30AntsReIBVVREKt3CqqIhceIVVREakRCqqJE4iIVVSXVURCqqAAAP7tqAAAAAAAAAA=">
          </div>
        }

        @if (images().length > 1) {
          <div class="absolute bottom-2 left-2 shadow-lg bg-white/75 text-grey-2 px-3 py-1 rounded-2xl text-sm">
            1/{{ images().length }}
          </div>
        }

        @if (careproviderUnit().mainCaregiverUnitType) {
          <div class="absolute bottom-2 right-2 flex justify-end items-center gap-1">
            <div
              [matTooltipClass]="'varden-tooltip'"
              [matTooltipPosition]="'below'"
              [matTooltip]="careproviderUnit().mainCaregiverUnitType.name"
              class="flex rounded-full bg-grey-10 justify-center items-center w-fit h-7 px-3 py-2 text-sm text-grey-0 max-w-52"
            >
              <span class="truncate max-w-full">{{ careproviderUnit().mainCaregiverUnitType.name }}</span>
            </div>
          </div>
        }
      </div>
    }

    @if (isHsa() && !mainImage()) {
      <div
        class="item-image w-full h-40 lg:h-44 relative rounded cursor-pointer bg-apricot-9 flex justify-center items-center">
        <app-segment-icon [imageSize]="140"
                          [isPriority]="true"
                          [segment]="mainSegment()"></app-segment-icon>
      </div>
    }

    <h1 class="text-2xl font-bold block md:hidden">{{ careproviderUnit().name }}</h1>

    <app-cpru-small-widgets class="flex md:hidden"></app-cpru-small-widgets>

    @if (displayBookingBtn()) {
      <div class="flex justify-stretch items-start gap-2 flex-row">
        @for (config of bookingConfigurationData(); track config.id) {
          <app-booking-btn
            [bookingConfigurationData]="config"
            [caregiverContactInfo]="careproviderUnit().caregiverContactInfo"
            [class]="'booking-btn test-booking-btn'"
            [gaEventAction]="eventActionEnum.VARDEN_BOOKING_CLICK_MAIN_BOOKING_BTN"
            [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
            [gaEventLabel]="careproviderUnit().id.toString()"
            [index]="0"
            [mainCaregiverUnitType]="careproviderUnit().mainCaregiverUnitType"
            [pageType]="pageType()"
            class="grow block w-full"
          ></app-booking-btn>
        }

        @if (!isHsa()) {
          @for (feature of careproviderUnit().customerFeatures; let i = $index; track feature.id) {
            <app-customer-feature
              [color]="'green'"
              [feature]="feature"
              [index]="i"
              [isCustomer]="careproviderUnit().isCustomer"
              [label]="featureLabel()"
              [pageType]="dLPageTypeEnum.CARE_PROVIDER_PAGE"
              class="grow block w-full"
            ></app-customer-feature>
          }
        }
      </div>
    }

    @if (isHsa()) {
      <app-cpru-cta-contact
        [bookingSettings]="careproviderUnit()?.bookingSettings"
        [careProviderUnitUrl]="careProviderUnitUrl()"
        [id]="careproviderUnit()?.id"
        [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
        [phoneNumbers]="careproviderUnit()?.caregiverContactInfo?.phoneNumbers"
        [websiteUrl]="careproviderUnit()?.caregiverContactInfo?.websiteUrl"
      ></app-cpru-cta-contact>
    }
  </div>
}

